export default {
    "entityName": "siterequest",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "request_arrival_date",
            "text": "Request arrival date",
            "type": "datetime",
            readonly: true
        },
        {
            value: 'response_eta',
            text: 'Estimated Time of Arrival',
            min: true,
            type: 'datetime',
            readonly: item => item.status !== 'CONFIRMED',
            validators: ['required']
        },
        {
            "value": "urgent",
            "text": "Urgent",
            "type": "check",
            mini: true,
            readonly: true,
            visible: item => item.urgent
        },
        {
            "value": "urgency_reason",
            "text": "Urgency reason",
            "type": "text",
            readonly: true,
            visible: item => item.urgency_reason
        },
        {
        value: 'note',
        text: 'Note',
        type: 'text',
        full: true,
        visible: item => item.note,
        readonly: true,
        },        
        {
            "value": "response_pdf",
            "text": "Response PDF",
            type: 'file',
            visible: (item, state) => state.user.role === 'Site' && item.status === 'REPLIED',
            validators: ['required']
        },
    ]
}